import { Component, OnInit, Input } from '@angular/core';
import { WhatsappService } from 'src/app/services/whatsapp.service';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { Storage } from '@ionic/storage-angular';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-modal-calidad',
  templateUrl: './modal-calidad.page.html',
  styleUrls: ['./modal-calidad.page.scss'],
})
export class ModalCalidadPage implements OnInit {
  @Input() conversacion: any;
  @Input() agente: string;
  @Input() cliente: string;
  chat: any;
  classUser: any;
  loading: any;
  mensajeCalidad: string;

  constructor(
    private serviceWa: WhatsappService,
    private serviceChat: ChatService,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    private storage: Storage
  ) {
    this.mensajeCalidad = '';
  }

  ngOnInit() {
    this.presentLoading('Cargando conversación')
    this.classUser = new ValidarToken(this.storage);
    this.chat = [];
    setTimeout(() => {
      this.getChat();
    }, 500);
  }

  getChat() {
    const query = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_admin: this.conversacion.id_admin,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_cliente: this.conversacion.id_cliente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_agente: this.conversacion.id_agente,
      conversacion: this.conversacion.conversacion,
    };
    // console.log(this.classUser);
    this.serviceWa.getChat(query, this.classUser.id, this.classUser.rol,
      this.classUser.token, '').subscribe(
        (res: any) => {
          // console.log(res);
          const { status, message } = res;
          if (status === 'success') {
            const { chats } = res;
            this.chat = chats;

            let conver = '';
            for (let index = 0; index < this.chat.length; index++) {
              if (this.chat[index].autor == 'cliente') {
                conver += `paciente: ${this.chat[index].mensaje} \n`;
              } else if (this.chat[index].autor == 'agente' || this.chat[index].autor == 'supervisor' || this.chat[index].autor == 'admin') {
                conver += `agente: ${this.chat[index].mensaje} \n`;
              }
            }
            //  console.log(conver, 'Conver unida');
            if (conver) {
              this.consultaCalidadIA(conver);
            } else {
              this.loading.dismiss();
              this.mensajeCalidad = 'No cuenta con suficiciente conversación para ser evaluado';
            }
            //  console.log(this.conversaciones);

          }
          else {
            this.loading.dismiss();
            this.presentToast('No se encontrarón conversaciones', 'danger');
            this.mensajeCalidad = 'No se encontrarón conversaciones';
          }
        },
        erro => {
          console.log(erro);
          this.loading.dismiss();
        });
  }

  consultaCalidadIA(conversacion) {
    const data = {
      mensaje: conversacion
    }
    this.serviceChat.getCalidadIA(data).subscribe(
      (res: any) => {
        // console.log(res);
        this.loading.dismiss();
        const { status } = res;
        if (status === 'success') {
          this.mensajeCalidad = res.response.choices[0].message.content;
          this.presentToast('Conversación calificada correctamente', 'success');

        }
        else {
          this.presentToast('No se pudo calificar de manera correcta', 'danger');
          this.mensajeCalidad = 'No se pudo calificar de manera correcta';
        }
      },
      erro => {
        console.log(erro);
        this.loading.dismiss();
      });
  }


  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      message: mensaje,
    });
    await this.loading.present();
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

}
